import {Component, OnInit, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {ViewMode} from "../../interfaces";
import Swal from "sweetalert2";
import {FormService} from "../../../services/form.service";
import {Observable, Observer, of, switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {TypeaheadMatch, TypeaheadModule} from "ngx-bootstrap/typeahead";
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-department-detail',
    templateUrl: './department-detail.component.html',
    styleUrl: './department-detail.component.scss',
    imports: [NgIf, FormsModule, ReactiveFormsModule, TypeaheadModule]
})
export class DepartmentDetailComponent implements OnInit {

    accessService = inject(AccessService);
    formService = inject(FormService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_department!: string;
    viewMode!: ViewMode;
    department: any;

    users$!: Observable<any[]>;
    noUserResult = false;
    selectedUser: any;

    loading = false;

    ngOnInit(): void {
        this.id_department = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_department == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: ['', Validators.required],
            lead: [''],
            _userSearch: this.fb.control(null),
        });

        if (this.id_department !== '0') {
            this.getDepartment();
        }

        // search users
        this.users$ = new Observable((observer: Observer<string | undefined>) => {
            observer.next(this.form.get('_userSearch').value);
        }).pipe(
            switchMap((query: string) => {
                if (query) {
                    this.noUserResult = false;

                    return this.dataService.request('User/listAzure', {
                        search: query
                    }).pipe(
                        map((data: any) => data.users)
                    );
                }

                return of([]);
            })
        );
    }

    getDepartment(): void {
        this.dataService.request('Department/get', {
            id_department: this.id_department
        }).subscribe(response => {
            this.department = response.department;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.department.id,
            name: this.department.name,
            lead: this.department.lead,
            _userSearch: this.department.lead,
        });
    }

    save(): void {
        this.form.patchValue({
            lead: this.selectedUser.displayName,
        })

        this.dataService.request('Department/save', {
            department: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/department']);
        });
    }

    update(): void {
        if (this.selectedUser) {
            this.form.patchValue({
                lead: this.selectedUser.displayName,
            })
        }

        this.dataService.request('Department/update', {
            department: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getDepartment();
        });
    }

    cancel(): void {
        this.router.navigate(['/department']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Abteilung wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Department/delete', {
                    id_department: this.id_department
                }).subscribe(() => {
                    this.cancel();
                });
            }
        });
    }

    onSelectUser($event: TypeaheadMatch): void {
        this.selectedUser = $event.item;
    }

    typeaheadUsersNoResults($event: boolean): void {
        this.noUserResult = $event;
    }

    typeaheadUsersLoading($event: boolean): void {
        this.loading = $event;
    }
}
